import { createContext } from "react";

export const MainHtmlElementContext = createContext<HTMLElement | null>(null);
